var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',[_c('v-row',[_c('v-col',[_c('v-btn',{staticClass:"primary",attrs:{"loading":_vm.isLoading},on:{"click":_vm.submitData}},[_vm._v("นำส่งด้วยตัวเอง")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }